import {User} from "@irati/types"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"

interface Messages {
  messageOne: string,
  messageTwo: string,
  messageReceiver: string,
  messageMany?: string,
  messageManyFull?: string
}

export default function buildMessageForStatementItem(
  users: User[],
  formatMessage: FormatMessage,
  messages: Messages,
  sender?: User
) {
  const {messageOne, messageTwo, messageMany, messageReceiver, messageManyFull} = messages

  if (users?.length) {
    if (users.length === 1) {
      return formatMessage(
        {id: messageOne},
        {user: firstnameLastname(users[0])}
      )
    } else if (users.length === 2) {
      return formatMessage(
        {id: messageTwo},
        {userOne: firstnameLastname(users[0]), userTwo: firstnameLastname(users[1])}
      )
    }
    if (messageManyFull) {
      const [singleUser, ...otherUsers] = users
      const usersFullNames = otherUsers.map((user) => firstnameLastname(user)).join(", ")
      return formatMessage(
        {id: messageManyFull},
        {otherUsers: usersFullNames, singleUser: firstnameLastname(singleUser)}
      )
    }
    return formatMessage(
      {id: messageMany},
      {userOne: firstnameLastname(users[0]), userTwo: firstnameLastname(users[1]), remainingUserCount: users.length - 2}
    )
  }
  return formatMessage({id: messageReceiver}, {sender: firstnameLastname(sender)})
}
